import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuList } from '@mui/material';

import { Url } from 'utils/urls';
import { formatCurrency } from 'utils/formatCurrency';
import { Constant } from 'utils/consts';
import { RepaymentNotification } from 'storage/notifications/notifications.model';
import { DesktopMenuAnchorContext } from '../../utils/desktopMenuAnchorContext';
import { MenuVisibilityContext } from '../../utils/menuVisibilityContext';
import { LinkStyled } from '../../styled/LinkStyled';
import NotificationItemWrapper from '../../styled/NotificationItemWrapper';
import NotificationItem from './NotificationItem';
import { MenuItemWrapper } from './MenuItemWrapper';

const RepaymentNotifications = ({
  notificationArray
}: {
  notificationArray: RepaymentNotification[];
}) => {
  const { t } = useTranslation();
  const { setNotificationAnchor } = useContext(DesktopMenuAnchorContext);
  const { setNotificationsVisible } = useContext(MenuVisibilityContext);

  const onItemClick = (contractId: number) => {
    console.log('clickedPaymentDone', contractId);
    // TODO, SMART-4414; SET A LOCAL NOTIFICATION DISPLAYED CHANGE FLAG
    setNotificationsVisible!(false);
    setNotificationAnchor!(null);
    // setClickedPaymentDone(contractId);
    // let arr = [contractId];
    // const notifications = localStorage.getItem('paymentsDone');
    // if (notifications) {
    //   const notificationsArray = JSON.parse(notifications);
    //   if (!notificationsArray.includes(contractId)) {
    //     arr = [...arr, ...notificationsArray];
    //   }
    // }
    // localStorage.setItem('paymentsDone', JSON.stringify(arr));
  };

  return (
    <MenuList sx={{ py: 0 }}>
      {notificationArray.map(({ context, displayed }, index) => {
        const { contractId, sourceContractId, paymentAmount } = context;
        const formattedCurrency = formatCurrency(
          'plain',
          paymentAmount.amount,
          paymentAmount.currency,
          true,
          true,
          true,
          true
        );
        if (typeof formattedCurrency !== 'string') {
          return null;
        }

        return (
          <MenuItemWrapper
            agreementId={sourceContractId}
            onClick={() => onItemClick(contractId)}
            key={contractId}
          >
            <LinkStyled
              to={`${Url.case}/${sourceContractId}#historySection`}
              data-link
              $isNotificationLink
            >
              <NotificationItemWrapper>
                <NotificationItem
                  icon="valid"
                  color="success"
                  text={t('DASHBOARD_RECENTLY_PAID', {
                    amount: formattedCurrency.replace(/ /, '\u00a0')
                  })}
                  linkText={t('NOTIFICATIONS_LINK_CHECK')}
                  fontWeight={
                    !displayed ? Constant.sevenHundred : Constant.sixHundred
                  }
                  withoutBorder={
                    index === notificationArray.length - Constant.one
                  }
                />
              </NotificationItemWrapper>
            </LinkStyled>
          </MenuItemWrapper>
        );
      })}
    </MenuList>
  );
};

export default RepaymentNotifications;
